import "./column-components.298cc9f3.js";
import "./column-components.d8adac4c.js";
import "./column-components.732a45eb.js";
import "./column-components.c709c904.js";
import $5vbrH$macrostrathyper from "@macrostrat/hyper";
import {forwardRef as $5vbrH$forwardRef, createElement as $5vbrH$createElement} from "react";
import {expandInnerSize as $5vbrH$expandInnerSize, extractPadding as $5vbrH$extractPadding, extractMargin as $5vbrH$extractMargin, removeMargin as $5vbrH$removeMargin, removePadding as $5vbrH$removePadding} from "@macrostrat/ui-components";
import $5vbrH$classnames from "classnames";


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $31c5935a31dcfddd$exports = {};

$parcel$export($31c5935a31dcfddd$exports, "SVGNamespaces", () => $31c5935a31dcfddd$export$59fd23dbe26daf79);
$parcel$export($31c5935a31dcfddd$exports, "SVG", () => $31c5935a31dcfddd$export$13f4b12aafeba5d6);
$parcel$export($31c5935a31dcfddd$exports, "ForeignObject", () => $31c5935a31dcfddd$export$86f236f5872f181);
$parcel$export($31c5935a31dcfddd$exports, "ColumnSVG", () => $31c5935a31dcfddd$export$31992eb1fd599dfe);




var $aVUB5 = parcelRequire("aVUB5");


var $kfx9r = parcelRequire("kfx9r");

var $42xfs = parcelRequire("42xfs");

var $9TRyj = parcelRequire("9TRyj");
const $31c5935a31dcfddd$export$59fd23dbe26daf79 = {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
};
const $31c5935a31dcfddd$export$13f4b12aafeba5d6 = (0, $5vbrH$forwardRef)((props, ref)=>{
    const { children: children, innerRef: innerRef, ...props1 } = props;
    const { style: style, ...rest } = (0, $5vbrH$expandInnerSize)(props1);
    // Sizing
    const { paddingLeft: paddingLeft, paddingTop: paddingTop } = (0, $5vbrH$extractPadding)(props);
    const margin = (0, $5vbrH$extractMargin)(props);
    const realRest = (0, $5vbrH$removeMargin)((0, $5vbrH$removePadding)(rest));
    return (0, $5vbrH$macrostrathyper)("svg", {
        ref: ref,
        style: {
            ...margin,
            ...style
        },
        ...realRest,
        ...$31c5935a31dcfddd$export$59fd23dbe26daf79
    }, (0, $5vbrH$macrostrathyper)("g", {
        transform: `translate(${paddingLeft},${paddingTop})`
    }, children));
});
const $31c5935a31dcfddd$export$86f236f5872f181 = (props)=>(0, $5vbrH$createElement)("foreignObject", props);
const $31c5935a31dcfddd$export$31992eb1fd599dfe = function(props) {
    //# Need to rework to use UI Box code
    const { children: children, className: className, innerRef: innerRef, style: style, ...rest } = props;
    const { pixelHeight: pixelHeight } = (0, $aVUB5.useColumn)();
    const nextProps = (0, $5vbrH$expandInnerSize)({
        innerHeight: pixelHeight,
        ...rest
    });
    const { paddingLeft: paddingLeft, paddingTop: paddingTop, innerHeight: innerHeight, innerWidth: innerWidth, height: height, width: width, ...remainingProps } = nextProps;
    return (0, $5vbrH$macrostrathyper)($31c5935a31dcfddd$export$13f4b12aafeba5d6, {
        className: (0, $5vbrH$classnames)(className, "section"),
        height: height,
        width: width,
        innerRef: innerRef,
        ...remainingProps,
        style: style
    }, (0, $5vbrH$macrostrathyper)("g.backdrop", {
        transform: `translate(${paddingLeft},${paddingTop})`
    }, children));
};
$parcel$exportWildcard($31c5935a31dcfddd$exports, $kfx9r);
$parcel$exportWildcard($31c5935a31dcfddd$exports, $42xfs);
$parcel$exportWildcard($31c5935a31dcfddd$exports, $9TRyj);


export {$31c5935a31dcfddd$export$59fd23dbe26daf79 as SVGNamespaces, $31c5935a31dcfddd$export$13f4b12aafeba5d6 as SVG, $31c5935a31dcfddd$export$86f236f5872f181 as ForeignObject, $31c5935a31dcfddd$export$31992eb1fd599dfe as ColumnSVG, $e150464fe9c7cb95$export$19fffca37ef3e106 as LocalStorage, $4a0ea9dcf1a07b76$export$32a0ad71237b9760 as ColumnBox, $4cfd4c889e62287b$export$e60368c40bae9fd4 as ColumnScroller};
//# sourceMappingURL=column-components.511bed71.js.map
